<script>
  import Audio from './Audio.svelte'
  import Image from './Image.svelte'
  import Video from './Video.svelte'
  import Abstract from './Abstract.svelte'

  export let selection
  export let changeSelectionIndex
</script>

<div class="overlay" data-kind={selection.kind}>
  <div class="layout">
    <div
      class="navarrows previous pointer"
      on:click={() => changeSelectionIndex(-1)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="45"
        viewBox="0 0 13.148 24.079"
      >
        <path
          fill="none"
          stroke="#e2e2e2"
          stroke-miterlimit="10"
          stroke-width=".35278"
          d="M13.027 23.95L.26 12.04 13.027.129"
        />
      </svg>
    </div>
    <div class="piece">
      {#if selection.kind === 'video'}
        <Video src={selection.src} />
      {:else if selection.kind === 'audio'}
        <Audio src={selection.src} />
      {:else if selection.kind === 'image'}
        <Image src={selection.src} srcset={selection.srcset}/>
      {/if}
    </div>
    <div
      class="navarrows next pointer"
      on:click={() => changeSelectionIndex(1)}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="45"
        viewBox="0 0 13.147 24.079"
      >
        <path
          fill="none"
          stroke="#e2e2e2"
          stroke-miterlimit="10"
          stroke-width=".35278"
          d="M.12.129l12.769 11.91L.12 23.95"
        />
      </svg>
    </div>
    <div class="abstract">
      <Abstract {selection} />
    </div>
  </div>

  <div class="close pointer" on:click={() => changeSelectionIndex(null)}>
    &Cross;
  </div>
</div>

<style lang="scss">
  .overlay {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 2vw;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 20px;
    margin-top: $frame-top-large;
    @include media-small {
      margin: 10px;
      margin-top: $frame-top-small;
    }
    background: #000000df;
    color: white;
    z-index: 100;
    /* background: #0ff5; */
  }
  .layout {
    display: flex;
    height: 100%;
    overflow: auto;
    width: 100%;
    justify-content: start;
    flex-wrap: wrap;
  }
  .piece {
    grid-column: 2 / -2;
    grid-row: 1 / -1;
    place-self: center center;
    //background: #0f05;
    flex: 1;
    max-width: 80vmin;
    order: 3;
    max-height: 100%;
    @include media-1col-only {
      max-width: initial;
    }
  }
  .abstract {
    align-self: flex-end;
    max-height: 100%;
    overflow: auto;
    order: 1;
    @include media-1col-only {
      order: 5;
      flex-basis: 100%;
    }
  }
  .navarrows {
    place-self: center;
    padding: 2vw;
    [data-kind=audio] & {
      visibility: hidden;
    }
  }
  .previous {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    place-self: end middle;
    order: 2;
  }
  .next {
    grid-column: -2 / -1;
    grid-row: 2 / 3;
    place-self: start middle;
    padding-right: 2em;
    order: 4;
  }
  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 20px;
    font-size: 60px;
    @include media-1col-only {
      font-size: 40px;
    }
  }
  .pointer:hover {
    cursor: pointer;
    user-select: none;
  }
  .metaTitle {
    color: var(--highlightColor);
  }
  .metaContent {
    color: var(--highlightColor);
  }
  .metaBlockContent {
    display: block;
    color: white;
  }
</style>
